import React, { useState } from "react";
import { useSelector } from "react-redux";
import TableRow from "./table-row";
import "./style.scss";

const Index = ({ searchQuery }) => {
  const loading = useSelector(
    (state) => state.campaigns.fetchAllEmails.loading
  );

  const campaigns = useSelector(
    (state) => state && state.campaigns && state.campaigns.content
  );

  const [selectDeleted, setSelectDeleted] = useState([]);

  const addDeletionArray = (e) => {
    const value = e.target.attributes.getNamedItem("campaignId").value;
    if (e.target.checked) {
      if (!selectDeleted.includes(value)) {
        setSelectDeleted((prevState) => [...prevState, value]);
      }
    } else {
      if (selectDeleted.includes(value)) {
        setSelectDeleted((selectDeleted) =>
          selectDeleted.filter((id) => id !== value)
        );
      }
    }
  };

  if (!loading)
    return (
      <>
        <section className="email-history-section">
          <div className="inner-email-history-container">
            <table className="campaigns-table">
              <thead>
                <tr>
                  <th>INNHOLD</th>
                  <th>SENDT FRA</th>
                  <th>REKKEVIDDE</th>
                  <th>UTSENDT AV</th>
                  <th>DATO SENDT</th>
                </tr>
              </thead>
              <tbody>
                {campaigns.map((singleEmail, index, arr) => {
                  if (!searchQuery) {
                    return (
                      <TableRow
                        selectDeleted={selectDeleted}
                        addDeletionArray={addDeletionArray}
                        singleEmail={singleEmail}
                        index={index}
                        arr={arr}
                      />
                    );
                  } else {
                    if (
                      singleEmail.snapshot
                        .toLowerCase()
                        .includes(searchQuery.toLowerCase())
                    ) {
                      return (
                        <TableRow
                          selectDeleted={selectDeleted}
                          addDeletionArray={addDeletionArray}
                          singleEmail={singleEmail}
                          index={index}
                          arr={arr}
                        />
                      );
                    }
                  }
                })}
              </tbody>
            </table>
          </div>
        </section>
      </>
    );
  return null;
};

export default Index;
